import { AnimationSettings } from "react-component-transition";
export const getForwardAndFadeEnterAnimation = (
  options?: KeyframeAnimationOptions,
  keyframes?: Keyframe[] | PropertyIndexedKeyframes,
): AnimationSettings => {
  return {
    keyframes: {
      transform: ["translate3d(-5%,0,0)", "translate3d(0%,0,0)"],
      opacity: [0, 1],
      ...keyframes,
    },
    options: {
      duration: 200,
      easing: "cubic-bezier(0.250, 0.460, 0.450, 0.940)",
      ...options,
    },
  };
};
